/* ==========================================================================
   VANYAN — theme behaviours. Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CART_SECTION = 'cart-drawer-section';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function routeRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function money(cents) {
    try {
      var fmt = window.VANYAN && window.VANYAN.moneyFormat;
      if (fmt) return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  /* ------------------------------------------------------------- marquee */
  function initMarquee(el) {
    if (el.dataset.vyMarqueeReady === '1') return;
    var track = $('.vy-marquee__track', el);
    if (!track) return;
    el.dataset.vyMarqueeReady = '1';

    var original = track.innerHTML;
    var guard = 0;
    while (track.scrollWidth < el.offsetWidth * 1.5 && guard < 12) {
      track.insertAdjacentHTML('beforeend', original);
      guard++;
    }
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    el.appendChild(clone);

    var pxPerSecond = parseFloat(el.dataset.speed || '60');
    if (pxPerSecond > 0 && track.scrollWidth > 0) {
      el.style.setProperty('--marquee-duration', track.scrollWidth / pxPerSecond + 's');
    }
  }

  /* ---------------------------------------------------------------- rail */
  function initRail(el) {
    if (el.dataset.vyRailReady === '1') return;
    el.dataset.vyRailReady = '1';
    var vp = $('.vy-rail__viewport', el);
    var prev = $('[data-rail-prev]', el);
    var next = $('[data-rail-next]', el);
    if (!vp) return;

    function step() {
      var first = vp.firstElementChild;
      if (!first) return vp.clientWidth;
      var gap = parseFloat(getComputedStyle(vp).columnGap || '16') || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      if (!prev || !next) return;
      var max = vp.scrollWidth - vp.clientWidth - 2;
      prev.disabled = vp.scrollLeft <= 2;
      next.disabled = vp.scrollLeft >= max;
    }
    on(prev, 'click', function () { vp.scrollBy({ left: -step(), behavior: REDUCED ? 'auto' : 'smooth' }); });
    on(next, 'click', function () { vp.scrollBy({ left: step(), behavior: REDUCED ? 'auto' : 'smooth' }); });
    on(vp, 'scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ----------------------------------------------------------- accordion */
  function initAccordion(el) {
    if (el.dataset.vyAccReady === '1') return;
    el.dataset.vyAccReady = '1';
    var single = el.dataset.single === 'true';

    $$('.vy-acc__btn', el).forEach(function (btn) {
      on(btn, 'click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        if (single && !open) {
          $$('.vy-acc__btn', el).forEach(function (other) {
            if (other === btn) return;
            other.setAttribute('aria-expanded', 'false');
            var p = document.getElementById(other.getAttribute('aria-controls'));
            if (p) p.dataset.open = 'false';
          });
        }
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.dataset.open = open ? 'false' : 'true';
      });
    });
  }

  /* ------------------------------------------------------------- gallery */
  function initGallery(el) {
    if (el.dataset.vyGalReady === '1') return;
    el.dataset.vyGalReady = '1';
    var slides = $('.vy-gal__slides', el);
    if (!slides) return;
    var thumbs = $$('.vy-gal__thumb', el);
    var dots = $$('.vy-gal__dots button', el);
    var prev = $('.vy-gal__arrow--prev', el);
    var next = $('.vy-gal__arrow--next', el);

    function index() { return Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1)); }
    function goTo(i) { slides.scrollTo({ left: slides.clientWidth * i, behavior: REDUCED ? 'auto' : 'smooth' }); }
    function sync() {
      var i = index();
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.children.length - 1;
    }
    thumbs.forEach(function (t, n) { on(t, 'click', function () { goTo(n); }); });
    dots.forEach(function (d, n) { on(d, 'click', function () { goTo(n); }); });
    on(prev, 'click', function () { goTo(Math.max(0, index() - 1)); });
    on(next, 'click', function () { goTo(Math.min(slides.children.length - 1, index() + 1)); });
    on(slides, 'scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();

    $$('.vy-gal__slide img', el).forEach(function (img) {
      on(img, 'click', function () {
        var zoomed = img.dataset.zoom === 'true';
        img.dataset.zoom = zoomed ? 'false' : 'true';
        img.style.transform = zoomed ? '' : 'scale(1.7)';
        img.style.cursor = zoomed ? 'zoom-in' : 'zoom-out';
        img.style.transition = REDUCED ? 'none' : 'transform 400ms cubic-bezier(.22,1,.36,1)';
      });
    });
  }

  /* ------------------------------------------------------------- buy box */
  function initBuy(el) {
    if (el.dataset.vyBuyReady === '1') return;
    el.dataset.vyBuyReady = '1';

    var qtyInput = $('[data-qty-input]', el);
    $$('[data-qty-step]', el).forEach(function (btn) {
      on(btn, 'click', function () {
        if (!qtyInput) return;
        var delta = parseInt(btn.dataset.qtyStep, 10) || 0;
        var min = parseInt(qtyInput.min, 10) || 1;
        qtyInput.value = Math.max(min, (parseInt(qtyInput.value, 10) || min) + delta);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var priceNow = $('[data-price-now]', el);
    var priceWas = $('[data-price-was]', el);

    $$('[data-purchase-option]', el).forEach(function (input) {
      on(input, 'change', function () {
        if (!input.checked || !priceNow) return;
        if (input.dataset.price) priceNow.textContent = input.dataset.price;
        if (priceWas) {
          if (input.dataset.compare) { priceWas.textContent = input.dataset.compare; priceWas.hidden = false; }
          else { priceWas.hidden = true; }
        }
      });
    });

    // Variant switching — keeps the hidden `id` input in step with the option selects.
    var section = el.closest('section') || document;
    var dataEl = $('[data-vy-variants]', section);
    var idInput = $('[data-vy-variant-input]', el);
    var selects = $$('[data-vy-option-index]', el);
    var submit = $('[data-vy-submit]', el);

    if (dataEl && idInput && selects.length) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      if (submit) submit.dataset.labelAvailable = submit.textContent.trim();

      var applyVariant = function () {
        var chosen = selects.map(function (sel) { return sel.value; });
        var match = variants.filter(function (variant) {
          return chosen.every(function (value, i) { return variant.options[i] === value; });
        })[0];
        if (!match) return;

        idInput.value = match.id;
        if (priceNow) priceNow.textContent = match.price;
        if (priceWas) {
          if (match.has_compare) { priceWas.textContent = match.compare; priceWas.hidden = false; }
          else { priceWas.hidden = true; }
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? submit.dataset.labelAvailable : 'Sold out';
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      };

      selects.forEach(function (sel) { on(sel, 'change', applyVariant); });
    }

    initProductForm($('form[action*="/cart/add"]', el));
  }

  /* --------------------------------------------------- product form AJAX */
  function initProductForm(form) {
    if (!form || form.dataset.vyFormReady === '1') return;
    form.dataset.vyFormReady = '1';

    on(form, 'submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-vy-submit]');
      if (btn && btn.getAttribute('aria-busy') === 'true') return; // guards double-add
      var original = btn ? btn.textContent : '';
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }

      var data = new FormData(form);
      data.append('sections', CART_SECTION);
      data.append('sections_url', window.location.pathname);

      fetch(routeRoot() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && res.body.description);
          if (btn) btn.textContent = 'Added to bag';
          renderCart(res.body, true);
          setTimeout(function () { if (btn) { btn.textContent = original; btn.removeAttribute('aria-busy'); } }, 1600);
        })
        .catch(function (err) {
          if (btn) { btn.textContent = original; btn.removeAttribute('aria-busy'); }
          var msg = form.querySelector('[data-vy-form-error]');
          if (!msg) {
            msg = document.createElement('p');
            msg.setAttribute('data-vy-form-error', '');
            msg.setAttribute('role', 'alert');
            msg.className = 'vy-buy__note';
            msg.style.color = '#b3261e';
            form.appendChild(msg);
          }
          msg.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        });
    });
  }

  /* ---------------------------------------------------------------- cart */

  /**
   * Swaps in the freshly rendered cart drawer that /cart/add.js returned, then
   * opens it. Rendering server-side is what keeps the drawer in step with the
   * real cart — dispatching events at the theme and hoping is not enough.
   */
  function renderCart(payload, shouldOpen) {
    var html = payload && payload.sections && payload.sections[CART_SECTION];
    var host = document.getElementById('shopify-section-' + CART_SECTION);
    if (html && host) {
      host.innerHTML = html;
      initCartAdders(host);
    }
    refreshCartUI();
    if (shouldOpen) openCartDrawer();
  }

  function openCartDrawer() {
    var opener = document.querySelector('[data-vy-open-cart]');
    if (opener) { opener.click(); return; }

    var run = function () {
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      var icon = document.querySelector('#header-component button[aria-controls="cart-drawer"]');
      if (icon) icon.click();
    };

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(run).catch(run);
    } else {
      run();
    }
  }

  function refreshCartUI() {
    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShippingBar(cart);
        updateCartBubble(cart.item_count || 0);
        initCartAdders(document);
      })
      .catch(function () {});
  }

  function updateCartBubble(count) {
    $$('[ref="cartBubble"]').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count === 0);
    });
    $$('[ref="cartBubbleCount"]').forEach(function (node) {
      node.textContent = count;
      node.classList.toggle('hidden', count === 0);
    });
  }

  function updateShippingBar(cart) {
    var fallback = (window.VANYAN && window.VANYAN.freeShippingThreshold) || 0;
    $$('[data-vy-ship-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || fallback;
      if (!threshold) { bar.hidden = true; return; }
      var total = cart.total_price || 0;
      var remaining = Math.max(0, threshold - total);
      var fill = $('.vy-cart-progress__fill', bar);
      var text = $('.vy-cart-progress__text', bar);
      if (fill) fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
      if (text) {
        text.innerHTML = remaining > 0
          ? (bar.dataset.textAway || 'You are [amount] away from free shipping').replace('[amount]', '<strong>' + money(remaining) + '</strong>')
          : (bar.dataset.textDone || 'Free shipping unlocked.');
      }
      bar.hidden = false;
    });
  }

  function initCartAdders(scope) {
    $$('[data-vy-add]', scope || document).forEach(function (btn) {
      if (btn.dataset.vyBound === '1') return;
      btn.dataset.vyBound = '1';
      on(btn, 'click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');
        var original = btn.textContent;
        btn.textContent = btn.dataset.addingText || 'Adding…';
        var openAfter = btn.dataset.openCart !== 'false';

        fetch(routeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(btn.dataset.vyAdd), quantity: 1 }],
            sections: [CART_SECTION],
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (payload) {
            btn.textContent = btn.dataset.addedText || 'Added';
            renderCart(payload, openAfter);
            setTimeout(function () { btn.textContent = original; btn.removeAttribute('aria-busy'); }, 1400);
          })
          .catch(function () { btn.textContent = original; btn.removeAttribute('aria-busy'); });
      });
    });
  }

  /* --------------------------------------------------------- review form */
  function initReviewForm(scope) {
    $$('[data-vy-revform-toggle]', scope || document).forEach(function (btn) {
      if (btn.dataset.vyBound === '1') return;
      btn.dataset.vyBound = '1';
      on(btn, 'click', function () {
        var form = document.getElementById(btn.getAttribute('aria-controls'));
        if (!form) return;
        var isOpen = form.dataset.open === 'true';
        form.dataset.open = isOpen ? 'false' : 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (!isOpen) {
          form.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
          var first = form.querySelector('input[type="text"], textarea');
          if (first) setTimeout(function () { first.focus(); }, REDUCED ? 0 : 420);
        }
      });
    });

    $$('[data-vy-stars]', scope || document).forEach(function (group) {
      if (group.dataset.vyBound === '1') return;
      group.dataset.vyBound = '1';
      var labels = $$('.vy-revform__star', group);

      function selected() {
        var checked = group.querySelector('input:checked');
        return checked ? parseInt(checked.value, 10) : 5;
      }
      function paint(n) {
        labels.forEach(function (label) {
          label.dataset.on = parseInt(label.dataset.star, 10) <= n ? 'true' : 'false';
        });
      }

      labels.forEach(function (label) {
        on(label, 'mouseenter', function () { paint(parseInt(label.dataset.star, 10)); });
        on(label, 'click', function () { setTimeout(function () { paint(selected()); }, 0); });
      });
      on(group, 'mouseleave', function () { paint(selected()); });
      paint(selected());
    });

    // Keep the panel open when it came back with an error or a success message.
    $$('.vy-revform', scope || document).forEach(function (form) {
      if (form.querySelector('.vy-revform__ok, .vy-revform__err')) {
        form.dataset.open = 'true';
        var ok = form.querySelector('.vy-revform__ok');
        if (ok && window.location.search.indexOf('contact_posted') > -1) {
          form.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
          ok.focus();
        }
      }
    });
  }

  /* ------------------------------------------------------------- reveals */
  function initReveals(scope) {
    var items = $$('[data-vy-reveal]', scope || document).filter(function (el) { return !el.classList.contains('vy-in'); });
    if (!items.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('vy-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('vy-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------- sticky ATC */
  function initSticky(el) {
    if (el.dataset.vyStickyReady === '1') return;
    el.dataset.vyStickyReady = '1';
    var sentinel = document.querySelector('[data-vy-sticky-sentinel]');
    if (!sentinel || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        el.dataset.visible = scrolledPast ? 'true' : 'false';
      });
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ------------------------------------------------------ recently viewed */
  var RV_KEY = 'vanyan:recently-viewed';

  function trackRecentlyViewed() {
    var id = document.body.dataset.vyProductId;
    if (!id) return;
    try {
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (x) { return x !== id; });
      list.unshift(id);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    } catch (e) {}
  }

  function renderRecentlyViewed() {
    var host = $('[data-vy-recent]');
    if (!host) return;
    var section = host.closest('section') || host;
    var current = document.body.dataset.vyProductId;
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
    ids = ids.filter(function (x) { return x !== current; });

    var shown = 0;
    $$('[data-vy-recent-card]', host).forEach(function (card) {
      var match = ids.indexOf(card.dataset.productId) > -1;
      card.hidden = !match;
      if (match) shown++;
    });
    section.hidden = shown === 0;
  }

  /* ----------------------------------------------------------- bootstrap */
  function boot(scope) {
    $$('.vy-marquee', scope).forEach(initMarquee);
    $$('[data-vy-rail]', scope).forEach(initRail);
    $$('[data-vy-accordion]', scope).forEach(initAccordion);
    $$('[data-vy-gallery]', scope).forEach(initGallery);
    $$('[data-vy-buy]', scope).forEach(initBuy);
    $$('[data-vy-sticky]', scope).forEach(initSticky);
    initCartAdders(scope);
    initReviewForm(scope);
    initReveals(scope);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var barTimer = null;
  function refreshShippingBarOnly() {
    clearTimeout(barTimer);
    barTimer = setTimeout(function () {
      fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateShippingBar(cart); updateCartBubble(cart.item_count || 0); })
        .catch(function () {});
    }, 140);
  }

  ready(function () {
    boot(document);
    trackRecentlyViewed();
    renderRecentlyViewed();
    refreshCartUI();

    // The theme re-renders the drawer on every cart change of its own.
    var host = document.getElementById('shopify-section-' + CART_SECTION);
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        initCartAdders(host);
        refreshShippingBarOnly();
      }).observe(host, { childList: true, subtree: true });
    }
  });

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:update'].forEach(function (ev) {
    document.addEventListener(ev, refreshShippingBarOnly);
  });

  window.VANYAN = window.VANYAN || {};
  window.VANYAN.refreshCart = refreshCartUI;
  window.VANYAN.boot = boot;
})();
